// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontSize, fontFamily } from '../../Design_System/DesignSystem';

// COMPONENTS
import { Text } from '../atoms/Text';
import { Icon } from '../atoms/Icon';
import { useLanguage } from '../../i18n/LanguageContext';

interface ThemeProps {
  setIsLightTheme: React.Dispatch<React.SetStateAction<boolean>>;
  isLightTheme: boolean;
}

const Theme = ({ setIsLightTheme, isLightTheme }: ThemeProps) => {
  const { t } = useLanguage();
  return (
    <MainTheme>
      <Light onClick={() => setIsLightTheme(true)}>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.tinos}
          bold={false}
          justify={false}
        >
          <>
            <Icon
              size={fontSize.mini}
              icon={isLightTheme ? 'dot' : 'emptyDot'}
              color={colors.tan}
            />{' '}
            <span> </span>
            {t.theme.light}
          </>
        </Text>
      </Light>
      <div onClick={() => setIsLightTheme(false)}>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.tinos}
          bold={false}
          justify={false}
        >
          <>
            <Icon
              size={fontSize.mini}
              icon={isLightTheme ? 'emptyDot' : 'dot'}
              color={colors.tan}
            />{' '}
            <span> </span>
            {t.theme.dark}
          </>
        </Text>
      </div>
    </MainTheme>
  );
};

const MainTheme = styled.div`
  display: flex;
  position: absolute;
  bottom: 10px;
  left: 40px;
  z-index: 3;
  cursor: pointer;
`;

const Light = styled.div`
  margin-right: 20px;
`;

export default Theme;
